import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { openWhatsApp } from '../utils/whatsapp';
export function FinalCTA() {
  const handleDirectWhatsApp = () => {
    openWhatsApp();
  };
  const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const data = Object.fromEntries(formData.entries());
    const message = `Hola, quisiera consultar disponibilidad y tarifas para Cabañas El Mirador.
    
*Nombre:* ${data.name}
*WhatsApp:* ${data.phone}
*Email:* ${data.email}
*Fecha estimada:* ${data.checkIn} al ${data.checkOut}
*Personas:* ${data.guests}

*Mensaje:* ${data.message}

Muchas gracias.`;
    openWhatsApp(message);
  };
  return <section id="contacto" className="py-16 md:py-24 relative overflow-hidden" data-id="element-91">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-92">
        <img src="https://images.unsplash.com/photo-1510798831971-661eb04b3739?q=80&w=2000&auto=format&fit=crop" alt="Fondo CTA" className="w-full h-full object-cover object-center" data-id="element-93" />
        <div className="absolute inset-0 bg-olive-dark/85 backdrop-blur-sm" data-id="element-94"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-95">
        <div className="flex flex-col lg:flex-row gap-10 md:gap-16 items-center" data-id="element-96">
          {/* Left Side: Text & Direct CTA */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="lg:w-5/12 text-center lg:text-left" data-id="element-97">
            <h2 className="text-3xl md:text-5xl lg:text-6xl text-white mb-4 md:mb-6" data-id="element-98">
              Consultá disponibilidad y reservá tu estadía
            </h2>
            <p className="text-base md:text-xl text-white/90 mb-8 md:mb-10 font-light leading-relaxed" data-id="element-99">
              Si querés disfrutar unos días de descanso en un entorno natural
              único, escribinos. Te ayudamos con disponibilidad, tarifas y toda
              la información que necesites para organizar tu próxima estadía.
            </p>
            <button onClick={handleDirectWhatsApp} className="inline-flex items-center justify-center gap-2 px-6 py-3 md:px-8 md:py-4 bg-white text-olive-dark rounded-full font-medium text-base md:text-lg hover:bg-sand-light transition-colors shadow-xl w-full sm:w-auto" data-id="element-100">
              <MessageCircle size={20} className="md:w-6 md:h-6" data-id="element-101" />
              Reservá por WhatsApp
            </button>
          </motion.div>

          {/* Right Side: Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="lg:w-7/12 w-full" data-id="element-102">
            <form onSubmit={handleFormSubmit} className="bg-white/95 backdrop-blur-md p-4 md:p-10 rounded-xl md:rounded-3xl shadow-2xl" data-id="element-103">
              <h3 className="text-xl md:text-3xl text-olive-dark mb-4 md:mb-8 font-serif" data-id="element-104">
                Consultá disponibilidad
              </h3>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-6" data-id="element-105">
                <div data-id="element-106">
                  <label htmlFor="name" className="block text-[11px] md:text-sm font-medium text-charcoal mb-1 md:mb-2" data-id="element-107">
                    Nombre
                  </label>
                  <input type="text" id="name" name="name" required className="w-full px-3 py-1.5 md:px-4 md:py-3 text-sm md:text-base rounded-md md:rounded-lg border border-sand-dark/50 bg-sand-light/50 focus:bg-white focus:ring-2 focus:ring-olive focus:border-olive outline-none transition-all" data-id="element-108" />
                </div>
                <div data-id="element-109">
                  <label htmlFor="phone" className="block text-[11px] md:text-sm font-medium text-charcoal mb-1 md:mb-2" data-id="element-110">
                    WhatsApp
                  </label>
                  <input type="tel" id="phone" name="phone" required className="w-full px-3 py-1.5 md:px-4 md:py-3 text-sm md:text-base rounded-md md:rounded-lg border border-sand-dark/50 bg-sand-light/50 focus:bg-white focus:ring-2 focus:ring-olive focus:border-olive outline-none transition-all" data-id="element-111" />
                </div>
                <div className="sm:col-span-2" data-id="element-112">
                  <label htmlFor="email" className="block text-[11px] md:text-sm font-medium text-charcoal mb-1 md:mb-2" data-id="element-113">
                    Email
                  </label>
                  <input type="email" id="email" name="email" required className="w-full px-3 py-1.5 md:px-4 md:py-3 text-sm md:text-base rounded-md md:rounded-lg border border-sand-dark/50 bg-sand-light/50 focus:bg-white focus:ring-2 focus:ring-olive focus:border-olive outline-none transition-all" data-id="element-114" />
                </div>
                <div className="grid grid-cols-2 gap-3 sm:col-span-2 sm:gap-6" data-id="element-115">
                  <div data-id="element-116">
                    <label htmlFor="checkIn" className="block text-[11px] md:text-sm font-medium text-charcoal mb-1 md:mb-2" data-id="element-117">
                      Ingreso
                    </label>
                    <input type="date" id="checkIn" name="checkIn" required className="w-full px-2 py-1.5 md:px-4 md:py-3 text-xs md:text-base rounded-md md:rounded-lg border border-sand-dark/50 bg-sand-light/50 focus:bg-white focus:ring-2 focus:ring-olive focus:border-olive outline-none transition-all text-charcoal" data-id="element-118" />
                  </div>
                  <div data-id="element-119">
                    <label htmlFor="checkOut" className="block text-[11px] md:text-sm font-medium text-charcoal mb-1 md:mb-2" data-id="element-120">
                      Salida
                    </label>
                    <input type="date" id="checkOut" name="checkOut" required className="w-full px-2 py-1.5 md:px-4 md:py-3 text-xs md:text-base rounded-md md:rounded-lg border border-sand-dark/50 bg-sand-light/50 focus:bg-white focus:ring-2 focus:ring-olive focus:border-olive outline-none transition-all text-charcoal" data-id="element-121" />
                  </div>
                </div>
                <div className="sm:col-span-2" data-id="element-122">
                  <label htmlFor="guests" className="block text-[11px] md:text-sm font-medium text-charcoal mb-1 md:mb-2" data-id="element-123">
                    Cantidad de personas
                  </label>
                  <select id="guests" name="guests" required className="w-full px-3 py-1.5 md:px-4 md:py-3 text-sm md:text-base rounded-md md:rounded-lg border border-sand-dark/50 bg-sand-light/50 focus:bg-white focus:ring-2 focus:ring-olive focus:border-olive outline-none transition-all text-charcoal" data-id="element-124">
                    <option value="" data-id="element-125">Seleccionar...</option>
                    <option value="1" data-id="element-126">1 persona</option>
                    <option value="2" data-id="element-127">2 personas</option>
                    <option value="3" data-id="element-128">3 personas</option>
                    <option value="4" data-id="element-129">4 personas</option>
                    <option value="5" data-id="element-130">5 personas</option>
                    <option value="6+" data-id="element-131">6 o más personas</option>
                  </select>
                </div>
                <div className="sm:col-span-2" data-id="element-132">
                  <label htmlFor="message" className="block text-[11px] md:text-sm font-medium text-charcoal mb-1 md:mb-2" data-id="element-133">
                    Mensaje
                  </label>
                  <textarea id="message" name="message" rows={2} required className="w-full px-3 py-1.5 md:px-4 md:py-3 text-sm md:text-base rounded-md md:rounded-lg border border-sand-dark/50 bg-sand-light/50 focus:bg-white focus:ring-2 focus:ring-olive focus:border-olive outline-none transition-all resize-none md:rows-3" data-id="element-134"></textarea>
                </div>
              </div>

              <button type="submit" className="w-full mt-4 md:mt-8 bg-olive text-white py-2.5 md:py-4 rounded-lg md:rounded-xl font-medium text-sm md:text-lg hover:bg-olive-dark transition-colors shadow-md" data-id="element-135">
                Enviar consulta
              </button>

              <p className="text-[10px] md:text-sm text-charcoal-light mt-3 md:mt-6 text-center leading-tight" data-id="element-136">
                Te responderemos a la brevedad con disponibilidad y más
                información sobre tu estadía.
              </p>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}